import { TabContentTranslations } from ".";

export const TAB_CONTENT_ES_MX: TabContentTranslations = {
	consolidated: "Competencia",
	extract: "Extracto",
	revenueSettlement: "Liquidación de Caja",
	new: "NUEVO",
	consolidatedTooltip:
		"Indica el período en que la venta u operación fue realizada, independientemente de la fecha de pago.",
	revenueSettlementTooltip:
		"Indica el período en que los valores fueron efectivamente pagados o recibidos.",
};
